import { render, staticRenderFns } from "./BottomBar.vue?vue&type=template&id=4ca5d9f4&scoped=true"
import script from "./BottomBar.vue?vue&type=script&lang=ts"
export * from "./BottomBar.vue?vue&type=script&lang=ts"
import style0 from "./BottomBar.vue?vue&type=style&index=0&id=4ca5d9f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5d9f4",
  null
  
)

export default component.exports